import { extraWideLabel, inputWrapper } from 'components/CalculatorInput/style'
import { row } from 'helpers/styles/grid'

export default {
  container: row,
  extraWideLabel: {
    ...extraWideLabel,
    display: 'inline-block'
  },
  inputWrapper: {
    ...inputWrapper,
    color: 'black',
    fontWeight: 400,
    lineHeight: '3.5rem',
    userSelect: 'none',
    display: 'inline-block',
    width: 'auto'
  },
  shortInputWrapper: {
    ...inputWrapper,
    height: '35px',
    color: 'black',
    fontWeight: 400,
    lineHeight: '3.5rem',
    userSelect: 'none',
    display: 'inline-block',
    width: 'auto'
  }
}



// WEBPACK FOOTER //
// ./src/components/CalculatorLabelAndTextDisplay/style.js